import type { ReactElement, ReactNode } from 'react'
import { Center, Loader, Stack, Text, ThemeIcon, Title } from '@mantine/core'
import { SizePrimitives, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from './terros/icon/MaterialSymbolIcon'
import { Page } from './page'
import { ButtonBack } from './buttons'

type NotReadyProps = {
  id?: string
  isLoading?: boolean
  error?: string
  children?: ReactElement
  data?: unknown
  inline?: boolean
}

export const NotReady = ({ inline, ...props }: NotReadyProps): ReactNode => {
  const { t } = useTranslation()

  if (!inline) {
    return (
      <Page>
        <NotReady {...props} inline />
      </Page>
    )
  }
  const { id, isLoading, error, data, children } = props
  if (isLoading) {
    return (
      <div className='grid flex-1 place-items-center'>
        <Stack align='center'>
          <Loader />
          <Text>{t('Loading {{id}}', { id: id ?? t('content') })}</Text>
        </Stack>
      </div>
    )
  }
  if (error) {
    return <ErrorScreen message={error} />
  }
  if (!data) return <ErrorScreen message={t('Unknown Error')} />
  return children
}

export const ErrorScreen = ({ message, back }: { message: string; back?: boolean }): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center className='flex-1'>
      <Stack align='center'>
        <ThemeIcon color='red'>
          <MaterialSymbolIcon icon='priority_high' size={SizePrimitives['6']} />
        </ThemeIcon>
        <Title order={2}>{t('Error')}</Title>
        <Text>{message}</Text>
        {back && <ButtonBack />}
      </Stack>
    </Center>
  )
}
